import DOMPurify from 'dompurify';
import { Marked } from 'marked';
import markedPlaintify from 'marked-plaintify';
import { sanitizeHtml } from '~/utils/html';
import { renderVideos } from '~/utils/video';

const mk = new Marked({
    async: false,
    gfm: true,
    breaks: true,
    silent: true,
});

const mkHtml = new Marked({
    async: false,
    gfm: true,
    breaks: true,
    silent: true,
});

const mkStrip = new Marked({
    async: false,
    gfm: true,
    breaks: true,
    silent: true,
}).use(markedPlaintify());

const ALLOWED_A_ATTRS = ['target', 'rel'];
const ALLOWED_IFRAME_ATTRS = [
    'allow',
    'allowfullscreen',
    'frameborder',
    'height',
    'scrolling',
    'src',
    'style',
    'title',
    'width',
];

// We need this hook because we use DOMPurify's USE_PROFILES
DOMPurify.addHook('uponSanitizeElement', (node, hookEvent) => {
    if (node.nodeName == 'IFRAME') {
        hookEvent.allowedTags[hookEvent.tagName] = true;
    }
});
DOMPurify.addHook('uponSanitizeAttribute', (node, hookEvent) => {
    switch (node.tagName) {
        case 'IFRAME':
            if (ALLOWED_IFRAME_ATTRS.includes(hookEvent.attrName)) {
                hookEvent.forceKeepAttr = true;
            }
            break;
        case 'A':
            if (ALLOWED_A_ATTRS.includes(hookEvent.attrName)) {
                hookEvent.forceKeepAttr = true;
            }
            break;
    }
});

// NOTE(toqueteos): the "as string" casts are necessary because Marked.parse
// returns string | Promise<string> and we never ever will be using the async
// flavor but that breaks the DOMPurify.sanitize typecheck

export function parseMarkdown(content: string): string {
    return sanitizeHtml(mk.parse(content) as string);
}

export function parseMarkdownWithHtml(content: string, skipRenderVideos = false): string {
    const s = skipRenderVideos ? content || '' : renderVideos(content);
    return sanitizeHtml(mkHtml.parse(s) as string);
}

export function stripMarkdown(content: string): string {
    return sanitizeHtml(mkStrip.parse(content) as string);
}

export function removeBlockQuotes(str: string): string {
    return str.replaceAll('<blockquote>', '').replaceAll('</blockquote>', '');
}
